module.exports = __webpack_public_path__ + "static/media/Transport.7be82865.svg";